import { selectedResourcesByMasterIdSelector } from "../selectedResourcesByMasterIdSelector";
import { isResourceKubernetes } from "../../../../utils/helpers/isResourceKubernetes";
import { RootState } from "@/store/store";

export const gridResourcesProtectDisabledSelector = (
  state: RootState,
  masterGridId: string,
) => {
  const selectedResources = selectedResourcesByMasterIdSelector(
    state,
    masterGridId,
  );

  if (!selectedResources) {
    return true;
  }

  return selectedResources.every((resource) => {
    if (!resource) {
      return true;
    }

    const accessType = isResourceKubernetes(resource)
      ? "read"
      : resource.account.provider_access_type;

    return accessType === "read" || resource.marked_for_deletion;
  });
};
